import { ListItem, ListItemPrefix } from '@material-tailwind/react';
import { Link } from 'react-router-dom';

const MenuItem = ({ text, route, icon }) => {
  const LIST_ITEM_STYLES =
    'select-none text-white  dark:text-white  hover:bg-blue-900 focus:bg-gray-300  dark:focus:bg-blue-900 active:font-bold hover:text-blue-900 focus:font-bold active:text-gray-900 data-[selected=true]:text-red-500 ';

  return (
    <Link to={route}>
      <ListItem className={LIST_ITEM_STYLES}>
        <ListItemPrefix>{icon}</ListItemPrefix>
        {text}
      </ListItem>
    </Link>
  );
};

export default MenuItem;
